export function PromoLine({ promoline, size }) {
  if (!promoline) return null
  const sizeClass = size === 'sm' ? 'badge-sm' : 'badge'
  return (
    <p
      style={`--bg-color:${promoline.backgroundColor?.value};--fg-color:${promoline.foregroundColor?.value}`}
      className={`${sizeClass} w-fit -rotate-1 whitespace-nowrap bg-[--bg-color] text-[--fg-color] sm:group-hover/card:animate-wiggle`}
    >
      {promoline.title}
    </p>
  )
}
